__turbopack_context__.v({
  "successContainer": "formSuccess-module-scss-module__RjbiqG__successContainer",
  "successText": "formSuccess-module-scss-module__RjbiqG__successText",
  "title": "formSuccess-module-scss-module__RjbiqG__title",
});
